import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	BusinessPartner,
	Category,
	CountryPhoneConfiguration,
	ErrorReportingBody,
} from '@oe-backend/types';
import { map, Observable } from 'rxjs';
import { AddressSuggestionsBE } from 'src/app/types/interfaces/order-address-suggestions.interface';
import { environment } from '../../../environments/environment';
import { CoreModule } from '../../core/core.module';
import { ResponseObjectApiInterface } from '../../types/interfaces/api-responses/response-object.api.interface';
@Injectable({
	providedIn: CoreModule,
})
export class ApiService {
	private apiBaseURL = environment.apiBaseUrl;
	private getCategoriesPath = '/categories';
	private validateAddress = '/Validation/address';
	private errorPath = '/design';
	private shipToCountries = '/Configuration/ShipToCountries';
	private reportErrorPath = '/errorReports';

	constructor(private readonly http: HttpClient) {}

	formatUrl(url: string, replacements: string[]) {
		return url.replace(/{(\d+)}/g, function (match, index) {
			return typeof replacements[index] == 'undefined' ? match : replacements[index];
		});
	}

	getCategories(): Observable<Category[]> {
		return this.http
			.get<ResponseObjectApiInterface<Category[]>>(this.apiBaseURL + this.getCategoriesPath)
			.pipe(
				map((response: ResponseObjectApiInterface<Category[]>) => {
					return response.data;
				}),
			);
	}

	validateShipToAddress(address: BusinessPartner) {
		return this.http
			.post<
				ResponseObjectApiInterface<AddressSuggestionsBE>
			>(this.apiBaseURL + this.validateAddress, address)
			.pipe(
				map((response: ResponseObjectApiInterface<AddressSuggestionsBE>) => {
					return response.data;
				}),
			);
	}
	reportError(error: ErrorReportingBody): Observable<ErrorReportingBody> {
		return this.http
			.post<
				ResponseObjectApiInterface<ErrorReportingBody>
			>(this.apiBaseURL + this.reportErrorPath, error)
			.pipe(
				map((response: ResponseObjectApiInterface<ErrorReportingBody>) => {
					return response.data;
				}),
			);
	}
	throwAPIError(): Observable<any> {
		return this.http.get<ResponseObjectApiInterface<any>>(this.apiBaseURL + this.errorPath).pipe(
			map((response: ResponseObjectApiInterface<any>) => {
				return response.data;
			}),
		);
	}

	getCountryPhoneCodes(): Observable<CountryPhoneConfiguration[]> {
		return this.http
			.get<ResponseObjectApiInterface<any>>(environment.apiBaseUrl + this.shipToCountries)
			.pipe(
				map((response) => {
					return response.data;
				}),
			);
	}
}
